import React, { useState, useEffect } from 'react';
import '../../styles/UserProfile.css';
import { updateProfile, getProfile } from '../../services/api';

function UserProfile() {
  const [profile, setProfile] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await getProfile();
        setProfile(data);
      } catch (err) {
        console.error('Failed to fetch profile:', err);
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setProfile({ ...profile, picture: URL.createObjectURL(e.target.files[0]) });
  };

  const handleSave = async () => {
    try {
      await updateProfile(profile);
      setIsEditing(false);
      alert('Profile updated successfully!');
    } catch (err) {
      alert('Failed to update profile. Please try again.');
    }
  };

  if (!profile) return <div>Loading...</div>;

  return (
    <div className="sp-user-profile">
      <h2 className="sp-profile-title">Your Profile</h2>
      {isEditing ? (
        <form className="sp-profile-form">
          <input
            className="sp-profile-input"
            name="name"
            value={profile.name || ''}
            onChange={handleChange}
            placeholder="Name"
          />
          <input
            className="sp-profile-input"
            name="email"
            value={profile.email || ''}
            onChange={handleChange}
            placeholder="Email"
          />
          <input
            className="sp-profile-input"
            name="company"
            value={profile.company || ''}
            onChange={handleChange}
            placeholder="Company"
          />
          <input
            className="sp-profile-input"
            name="phone"
            value={profile.phone || ''}
            onChange={handleChange}
            placeholder="Phone"
          />
          <input
            className="sp-profile-file"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
          />
          <button className="sp-profile-btn" type="button" onClick={handleSave}>Save</button>
        </form>
      ) : (
        <div className="sp-profile-details">
          {profile.picture && <img className="sp-profile-pic" src={profile.picture} alt="Profile" />}
          <p className="sp-profile-text"><strong>Name:</strong> {profile.name}</p>
          <p className="sp-profile-text"><strong>Email:</strong> {profile.email}</p>
          <p className="sp-profile-text"><strong>Company:</strong> {profile.company}</p>
          <p className="sp-profile-text"><strong>Phone:</strong> {profile.phone}</p>
          <button className="sp-profile-btn" onClick={() => setIsEditing(true)}>Edit Profile</button>
        </div>
      )}
    </div>
  );
}

export default UserProfile;